import NiceScale from './NiceScale';

export default {
  NiceScale,
};
